'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  appearance: none;\n  display: block;\n  border-radius: ', ';\n  height: 4px;\n  cursor: pointer;\n\n  &::-webkit-slider-thumb {\n    width: 16px;\n    height: 16px;\n    background-color: currentColor;\n    border: 0;\n    border-radius: ', ';\n    appearance: none;\n  }\n\n  ', ' ', ' ', ';\n'], ['\n  appearance: none;\n  display: block;\n  border-radius: ', ';\n  height: 4px;\n  cursor: pointer;\n\n  &::-webkit-slider-thumb {\n    width: 16px;\n    height: 16px;\n    background-color: currentColor;\n    border: 0;\n    border-radius: ', ';\n    appearance: none;\n  }\n\n  ', ' ', ' ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledSystem = require('styled-system');

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Slider = _styledComponents2.default.input.attrs({ type: 'range' })(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.pill;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.pill;
}, _styledSystem.space, _styledSystem.width, _styledSystem.color);

Slider.displayName = 'Input';

Slider.propTypes = _extends({}, _styledSystem.propTypes.space, _styledSystem.propTypes.width, _styledSystem.propTypes.color);

Slider.defaultProps = {
  theme: _theme2.default,
  w: 1,
  bg: 'smoke',
  color: 'primary'
};

exports.default = Slider;